export const PHONE_DIGITS_ONLY = "Phone number must contain only numbers (with optional + prefix)"
export const PHONE_TOO_SHORT = "Phone number must have at least 10 digits"
export const PHONE_TOO_LONG = "Phone number cannot exceed 15 digits"

export function validateLeadPhoneFormat(phone: string | null | undefined): string | null {
  if (!phone || phone.length === 0) return null
  const phoneWithoutPlus = phone.startsWith("+") ? phone.slice(1) : phone
  if (!/^\d+$/.test(phoneWithoutPlus)) return PHONE_DIGITS_ONLY
  if (phoneWithoutPlus.length < 10) return PHONE_TOO_SHORT
  if (phoneWithoutPlus.length > 15) return PHONE_TOO_LONG
  return null
}
